<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="用户名称"
            v-model:value="searchForm.userName"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="用户昵称"
            v-model:value="searchForm.nickName"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-input
            placeholder="手机"
            v-model:value="searchForm.phonenumber"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item> </a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="账户列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button @click="toAdd" type="primary">添加</a-button>
      </template>

      <a-table
        style="overflow-y:scroll"
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :row-key="(r) => r.userId"
        :loading="loading"
      >
        <template v-slot:switch="{ text, record, index }">
          <a-switch
            :defaultChecked="record.status == 0 ? true : false"
            @change="onChange(record, index)"
          />
        </template>

        <template v-slot:button="{ text, record }">
          <a-button type="primary" @click="edit(record)"> 编辑 </a-button>
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>

    <a-modal v-model:visible="modalVisible" title="添加账号" @ok="handleOk">
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="登陆账号" name="userName" v-if="!isedit">
          <a-input
            v-model:value="submitForm.userName"
            placeholder="登陆账号"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="登陆密码" name="password" v-if="!isedit">
          <a-input-password
            v-model:value="submitForm.password"
            placeholder="登陆密码"
            class="input_password"
          />
        </a-form-item>
        <a-form-item label="用户昵称" name="nickName">
          <a-input
            v-model:value="submitForm.nickName"
            placeholder="用户昵称"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="归属部门" name="deptId">
          <df-selectDeptTree
            :model="submitForm"
            @setValue="setValue"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="手机号码" name="phonenumber">
          <a-input
            v-model:value="submitForm.phonenumber"
            placeholder="手机号码"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="角色" name="roleIds">
          <df-selectRoleList
            :model="submitForm"
            v-model:value="submitForm.roleIds"
            @setValue="setRoleValue"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="是否开启" name="main">
          <a-radio-group
            v-model:value="submitForm.status"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 是 </a-radio-button>
            <a-radio-button value="1"> 否 </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import userApi from "@axios/sys/user";
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { useRouter } from "vue-router";
import { notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import moment from "moment";

export default {
  name: "userIndex",
  components: {},
  setup() {
    let submitFormref = "";
    const setsubmitForm = (el) => {
      submitFormref = el;
    };

    var checkPhone = async (rule, value) => {
      if (!value) {
        return Promise.reject("手机号不能为空");
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          Promise.resolve();
        } else {
          return Promise.reject("请输入正确的手机号");
        }
      }
    };
    const checkUserName = async (rule, value, callback) => {
      if (!value) {
        return Promise.reject("用户名不能为空！");
      }
      return !(value = await userApi.checkUserNameUnique(value))
        ? Promise.reject("用户名已经存在")
        : "";
    };

    const router = useRouter();
    const modalVisible = ref(false);
    let submitForm = reactive({
      userName: "",
      password: "",
      nickName: "",
      deptId: "",
      status: "",
      phonenumber: "",
      roleIds: "",
    });
    const rules = {
      userName: [
        { required: true, message: "请输入用户名", trigger: "blur" },
        { validator: checkUserName, trigger: "blur" },
      ],
      password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
      deptId: [{ required: true, message: "请选择部门", trigger: "change" }],
      // roleIds: [
      //   {required: true, message: '请选择角色', trigger: 'change'}
      // ],
      phonenumber: [
        { required: true, message: "请输入手机号码", trigger: "blur" },
        { validator: checkPhone, trigger: "blur" },
      ],
    };

    let loading = ref(false);
    let searchForm = reactive({
      userName: "",
      nickName: "",
      phonenumber: "",
    });
    let searchParams = reactive({
      userName: "",
      nickName: "",
      phonenumber: "",
    });

    let names = ref("");

    let list = ref([]);

    const columns = [
      {
        title: "账户",
        dataIndex: "userName",
        width: 200,
        align: "center",
      },
      {
        title: "用户昵称",
        dataIndex: "nickName",
        width: 200,
        align: "center",
      },
      {
        title: "部门",
        dataIndex: "dept.deptName",
        width: 200,
        align: "center",
      },
      {
        title: "手机号",
        dataIndex: "phonenumber",
        width: 200,
        align: "center",
      },
      {
        title: "开关",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "switch" },
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 200,
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "button" },
      },
    ];

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const stateValue = ["关闭", "开启"];

    const searchAction = () => {
      searchParams.userName = searchForm.userName;
      searchParams.nickName = searchForm.nickName;
      searchParams.phonenumber = searchForm.phonenumber;

      console.log(searchParams);
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };
    //查询列表
    const getList = () => {
      loading.value = true;
      let params = {
        nickName: searchParams.nickName ? searchParams.nickName : null,
        userName: searchParams.userName ? searchParams.userName : null,
        phonenumber: searchParams.phonenumber ? searchParams.phonenumber : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };
      userApi.userList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    const reset = () => {
      searchForm.userName = "";
      searchForm.phonenumber = "";
      searchAction();
    };
    const toLook = (row) => {
      router.push({
        name: "addShopIndex",
        query: {
          id: row.userId,
          type: "look",
        },
      });
    };

    const toAdd = () => {
      submitForm.userName = "";
      submitForm.password = "";
      submitForm.phonenumber = "";
      (submitForm.nickName = ""),
        (submitForm.deptId = ""),
        (submitForm.status = "0"),
        (submitForm.roleIds = []),
        (modalVisible.value = true);
      isedit.value = false;
    };
    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const handleOk = () => {
      submitFormref
        .validate()
        .then(() => {
          //添加账号
          if (isedit.value) {
            let params = {
              userId: editid,
              phonenumber: submitForm.phonenumber,
              nickName: submitForm.nickName,
              deptId: submitForm.deptId,
              roleIds: submitForm.roleIds,
            };
            userApi.userEdit(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "编辑成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          } else {
            userApi.userAdd(submitForm).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "添加成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //部门值
    const setValue = (val) => {
      submitForm.deptId = val;
    };
    //角色值
    const setRoleValue = (val) => {
      submitForm.roleIds = val;
    };

    let isedit = ref(false);
    let editid = "";
    const edit = (row) => {
      if (submitFormref) submitFormref.resetFields();
      editid = row.userId;
      isedit.value = true;
      modalVisible.value = true;
      submitForm.userName = row.userName;
      submitForm.password = "";
      submitForm.phonenumber = row.phonenumber;
      (submitForm.nickName = row.nickName),
        (submitForm.deptId = row.deptId),
        (submitForm.status = row.status),
        (submitForm.roleIds = row.roleIds);
    };

    const onChange = (row, index) => {
      userApi
        .switchState(row.userId)
        .then(() => {
          notification.open({
            message: "修改成功",
            icon: <SmileOutlined style="color: #108ee9" />,
          });
          getList();
        })
        .catch(() => {
          notification.open({
            message: "修改失败",
            icon: <SmileOutlined style="color: #108ee9" />,
          });
          getList();
        });
    };
    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    getList();

    return {
      onChange,
      isedit,
      edit,
      names,
      staticof,
      loading,
      searchForm,
      searchParams,
      list,
      columns,
      pageObj,
      stateValue,
      searchAction,
      reset,
      toLook,
      toAdd,
      modalVisible,
      moment,
      disabledDate(current) {
        return current && current < moment().endOf("day");
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules,
      submitForm,
      handleOk,
      setsubmitForm,
      setValue,
      setRoleValue,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}

.input_password {
  width: 282px;
}
</style>
